import { getDaysInMonth } from 'date-fns/getDaysInMonth';
import { toDate } from 'date-fns/toDate';

import { getGridPriceData, getSelectedMonth, hasDirectsForDate } from '.';

import type { Direction, State } from './types';

const getWholeMonthData = (state: State, direction: Direction) => {
  const monthDate = getSelectedMonth(state, direction);
  // Type-guard for the null case.
  if (!monthDate) {
    return [];
  }
  const numberOfDays = getDaysInMonth(monthDate);
  const wholeMonthData = [];
  for (let i = 1; i <= numberOfDays; i += 1) {
    const dayDate = toDate(monthDate);
    dayDate.setDate(i);
    const dayPriceData =
      getGridPriceData(state, dayDate, direction) &&
      getGridPriceData(state, dayDate, direction).price;
    const dayDirectAvailability = hasDirectsForDate(state, dayDate, direction);
    wholeMonthData.push({
      price: dayPriceData,
      directAvailable: dayDirectAvailability,
      date: dayDate,
    });
  }
  return wholeMonthData;
};

export default getWholeMonthData;
